import googleImg from '../assests/google.png';
import linkedinImg from '../assests/linkedin.png';
import facebookImg from '../assests/facebook.png';
import instagramImg from '../assests/instagram.png';
import defaultImg from '../assests/google.png';
//  import snapchatImg from '../assests/snapchat.svg'
import snapchatImg from '../assests/snapchat_1.svg'
import spotify from "../assests/spotify.svg";

export const getPlatformImg = (platform_id) => {
  // Convert the platform_id to a number to handle both string and number inputs
  const id = Number(platform_id);

  switch (id) {
    case 1:
      return googleImg;
    case 2:
      return linkedinImg;
    case 3:
      return snapchatImg;
    case 4:
      return spotify;
    case 6:
        return facebookImg;
    case 7:
      return instagramImg;
    default:
      return defaultImg;
  }
}

export const getImgSrc=(imgName,type='png')=>{
  return require(`../assests/${imgName}.${type}`)
}

export const getIconSrc=(imgName,type='svg')=>{
  return require(`../assests/icon/${imgName}.${type}`)
}


